import { atom, selector } from "recoil"
import { accountSelector } from "src/recoil/selectors/account/accountSelector"

export const schoolDepartmentIdState = atom({
  key: "atoms/account/schoolDepartmentIdState",
  default: selector({
    key: "atoms/account/schoolDepartmentIdState_default",
    get: ({ get }) => {
      const account = get(accountSelector)
      return account?.schoolDepartmentId
    },
  }),
})
